export default "__VITE_ASSET__0BIQdjgw__"